import { useEffect, useState } from 'react';
import { runtimeApi, type RuntimeDashboard } from '../../api/moduleruntime';

export function RuntimeActivityPage() {
  const [dashboard, setDashboard] = useState<RuntimeDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void runtimeApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Runtime Activity</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ol className="mt-6 space-y-3">
        {dashboard?.recent_activity.map((a) => (
          <li key={a.id} className="rounded-xl border px-4 py-3 dark:border-slate-700">
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium">{a.action}</span>
              <span className="text-xs text-slate-500">{new Date(a.created_at).toLocaleString()}</span>
            </div>
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{a.module_id}: {a.details}</p>
          </li>
        ))}
        {!dashboard?.recent_activity?.length && <p className="text-sm text-slate-500">No recent activity.</p>}
      </ol>
    </div>
  );
}
